import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col } from 'antd';

import { SectionWrapper } from 'common/components';
import { useGetWalmartProductAssets } from '../../queries';
import ImageUrlCard from './ImageUrlCard';
import ProductImageModal from './ProductImageModal';
import ButtonAddImageUrl from './ButtonAddImageUrl';
import './styles.less';

const SelectProductImageUrlInput = (props) => {
  const { onChange, value, productId } = props;

  const [isProductImageModalVisible, setIsProductImageModalVisible] =
    useState(false);
  const [selected, setSelected] = useState([]);

  const toggleProductImageModal = () => {
    setIsProductImageModalVisible((prev) => !prev);
  };

  const { data: productImageData, isLoading } = useGetWalmartProductAssets({
    productId,
    enabled: isProductImageModalVisible,
  });

  const flattenProductImageData = useMemo(() => {
    return productImageData?.reduce(
      (combinedList, imageCategory) =>
        combinedList.concat(imageCategory?.assetInfos || []),
      []
    );
  }, [JSON.stringify(productImageData)]);

  const onInputChange = () => {
    if (selected?.length === 0) {
      onChange(null);
    } else {
      const selectedImage = flattenProductImageData?.find(
        (imageItem) => imageItem?.digitalAssetId === selected?.[0]
      );

      if (selectedImage) {
        const imageFile =
          selectedImage?.thumb1000 || selectedImage?.originalFile;
        const rivirImageUrl = window.origin + imageFile;
        const imageUrl =
          selectedImage?.assetName === 'Walmart placeholder image'
            ? imageFile
            : rivirImageUrl;
        onChange(imageUrl);
      }
    }

    toggleProductImageModal();
  };

  useEffect(() => {
    const checkIfProductImageItemContainValue = (productImageItem) => {
      return value?.includes(productImageItem?.thumb1000);
    };

    //* map value to selected state
    const setSelectedByValue = () => {
      const selectedImage = flattenProductImageData?.find(
        checkIfProductImageItemContainValue
      );

      if (selectedImage) {
        setSelected([selectedImage?.digitalAssetId]);
      } else {
        setSelected([]);
      }
    };

    setSelectedByValue();
  }, [value, JSON.stringify(flattenProductImageData)]);

  const handRemoveImage = () => {
    onChange(null);
  };

  const handleEditImage = () => {
    toggleProductImageModal();
  };

  return (
    <SectionWrapper style={{ padding: 0 }} containerStyle={{ padding: 13 }}>
      {value ? (
        <RenderImageUrlValue
          imageInfo={{ thumb1000: value }}
          handleRemoveImage={handRemoveImage}
          handleEditImage={handleEditImage}
        />
      ) : (
        <ButtonAddImageUrl onClick={toggleProductImageModal} />
      )}
      <>
        <ProductImageModal
          multiple={false}
          toggleProductImageModal={toggleProductImageModal}
          visible={isProductImageModalVisible}
          onSubmitSelectedImages={onInputChange}
          productImageData={productImageData}
          selected={selected}
          setSelected={setSelected}
          isProductImageModalVisible={isProductImageModalVisible}
          isLoading={isLoading}
        />
      </>
    </SectionWrapper>
  );
};

const RenderImageUrlValue = ({
  imageInfo,
  handleRemoveImage,
  handleEditImage,
}) => {
  return (
    <>
      {imageInfo && (
        <Row style={{ marginBottom: 10 }}>
          <Col xs={24}>
            <ImageUrlCard
              thumb1000={imageInfo?.thumb1000}
              handleRemoveImage={handleRemoveImage}
              handleEditImage={handleEditImage}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={24}>
          <ButtonAddImageUrl onClick={handleEditImage} />
        </Col>
      </Row>
    </>
  );
};

export default SelectProductImageUrlInput;
